import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, List, Paper, useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import companyLogoDark from '../../assets/images/NOVUS OMNIFLEET FINAL LOGO-01.png';
import companyLogoLight from '../../assets/images/NOVUS OMNIFLEET FINAL LOGO-02.png';
import logoName from '../../assets/images/LogoName.svg';
import NavButton from '../../common/components/NavButton';
import DashboardIcon from '../../iconComponent/dashboardIcon';
import TripsIcon from '../../iconComponent/tripsIcon';
import ReportsIcon from '../../iconComponent/reportsIcon';
import AllReportsIcon from '../../iconComponent/ReportsIcon1';
import ScheduleReportsIcon from '../../iconComponent/clockIcon';
import DirectoriesIcon from '../../iconComponent/direcoriesIcon';
import AdminIcon from '../../iconComponent/adminIcon';
import AlarmIcon from '../../iconComponent/alarmIcon';
import RouteIcon from '@mui/icons-material/Route';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import GroupsIcon from '@mui/icons-material/Groups';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VehicleAlerts from '../../iconComponent/Vehicle_Alerts';
import GeoFenceIcon from '../../iconComponent/geofenceIcon';
import DeviceIcon from '../../iconComponent/DeviceIcon';
import DocumentIcon from '../../iconComponent/DocumentBlockIcon';
import PerformanceIcon from '../../iconComponent/DriverPerformanceIcon';
import DriverIcon from '../../iconComponent/driverIcon';
import DriverAlerts from '../../iconComponent/DriverAlerts';
import DriverCoaching from '../../iconComponent/DriverCoaching';
import IgnitionBasedIcon from '../../iconComponent/IgnitionBasedIcon';
import TripCreationIcon from '../../iconComponent/tripCreationIcon';
import SupportIcon from '../../iconComponent/SupportIcon';
import HelpDeskIcon from '../../iconComponent/HelpDeskIcon';
import TroubleShootIcon from '../../iconComponent/TroubleShootIcon';
import BroadcastIcon from '../../iconComponent/BroadcastIcon';
import { useAuth } from '../../authContext/useAuth';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

import {
  getPermissionCategoryFromNavItem,
  getPermissionSubcategoryFromNavSubcategory,
  hasCategoryAccess,
  hasSubcategoryAccess,
} from '../../utils/permissionConstants';
import { ROUTE } from '../../router/Constant';

interface NavItem {
  text: string;
  icon: any;
  path: string;
  hasArrow?: boolean;
  children?: NavItem[];
  adminOnly?: boolean;
  sudperAdminOnly?: boolean;
}

const navArrItems: NavItem[] = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: ROUTE.dashboard },
  {
    text: 'Vehicles',
    icon: <DirectionsCarIcon />,
    path: `${ROUTE.vehicles}`,
  },
  {
    text: 'Trips',
    icon: <TripsIcon />,
    path: ROUTE.trips,
    hasArrow: true,
    children: [
      {
        text: 'User Created Trips',
        icon: <TripCreationIcon />,
        path: ROUTE.trips,
      },
      {
        text: 'Ignition Based Trips',
        icon: <IgnitionBasedIcon />,
        path: ROUTE.ignitionTrips,
      },
    ],
  },
  {
    text: 'Reports',
    icon: <ReportsIcon />,
    path: ROUTE.reports,
    hasArrow: true,
    children: [
      { text: 'All Reports', icon: <AllReportsIcon />, path: ROUTE.reports },
      {
        text: 'Scheduled Reports',
        icon: <ScheduleReportsIcon />,
        path: ROUTE.scheduledReports,
      },
    ],
  },
  { text: 'Documents', icon: <DocumentIcon />, path: ROUTE.document },
  {
    text: 'Alerts',
    icon: <AlarmIcon />,
    path: ROUTE.Alarm,
    hasArrow: true,
    children: [
      {
        text: 'Vehicle Alerts',
        icon: <VehicleAlerts />,
        path: `${ROUTE.Alarm}/${ROUTE.VehicleAlerts}`,
      },
      {
        text: 'Driver Alerts',
        icon: <DriverAlerts />,
        path: `${ROUTE.Alarm}/${ROUTE.DriverAlerts}`,
      },
      {
        text: 'Broadcast',
        icon: <BroadcastIcon />,
        path: `${ROUTE.Alarm}/${ROUTE.Broadcast}`,
      },
    ],
  },
  {
    text: 'Driver Performance',
    icon: <PerformanceIcon />,
    path: `${ROUTE.DriverPerformance}`,
  },
  {
    text: 'Driver Coaching',
    icon: <DriverCoaching />,
    path: `${ROUTE.DriverCoaching}`,
    hasArrow: false,
  },
  {
    text: 'Directories',
    icon: <DirectoriesIcon />,
    path: ROUTE.directories,
    hasArrow: true,
    children: [
      {
        text: 'Geofences',
        icon: <GeoFenceIcon />,
        path: `${ROUTE.directories}/${ROUTE.geofences}`,
      },
      {
        text: 'Routes',
        icon: <RouteIcon />,
        path: `${ROUTE.directories}/${ROUTE.routes}`,
      },
      {
        text: 'Addresses',
        icon: <LocationOnIcon />,
        path: `${ROUTE.directories}/${ROUTE.addresses}`,
      },
      // {
      //   text: 'Vehicles',
      //   icon: <DirectionsCarIcon />,
      //   path: `${ROUTE.directories}/${ROUTE.vehicles}`,
      // },
      {
        text: 'Depot',
        icon: <GroupsIcon />,
        path: `${ROUTE.directories}/${ROUTE.groups}`,
      },
      {
        text: 'Devices',
        icon: <DeviceIcon />,
        path: `${ROUTE.directories}/${ROUTE.devices}`,
      },
      {
        text: 'My Drivers',
        icon: <EmojiPeopleIcon />,
        path: `${ROUTE.directories}/${ROUTE.driver}`,
      },
    ],
  },
  {
    text: 'Service Manager',
    icon: <SupportIcon />,
    path: ROUTE.serviceMaster,
  },
  {
    text: 'Support',
    icon: <SupportIcon />,
    path: ROUTE.support,
    hasArrow: true,
    children: [
      {
        text: 'HelpDesk',
        icon: <HelpDeskIcon />,
        path: `${ROUTE.support}/${ROUTE.helpDesk}`,
      },
    ],
  },
  {
    text: 'Admin',
    icon: <AdminIcon />,
    path: ROUTE.admin,
    hasArrow: true,
    children: [
      {
        text: 'Customization',
        icon: <DashboardCustomizeIcon />,
        path: `${ROUTE.admin}/${ROUTE.customization}`,
      },
      // {
      //   text: 'User Accounts',
      //   icon: <ManageAccountsIcon />,
      //   path: `${ROUTE.admin}/${ROUTE.userAccount}`,
      // },
      {
        text: 'Live Stream Config',
        icon: <SettingsSuggestIcon />,
        path: `${ROUTE.admin}/${ROUTE.liveStreamConfig}`,
      },
      {
        text: 'User Access Controls',
        icon: <AccessibilityNewIcon />,
        path: `${ROUTE.admin}/${ROUTE.userAccessControls}`,
      },
      {
        text: 'Banner Configuration',
        icon: <ViewCarouselIcon />,
        path: `${ROUTE.admin}/${ROUTE.userBannerCreate}`,
      },
      {
        text: "Manage Subscriptions",
        icon: <SubscriptionsIcon />,
        path: `${ROUTE.admin}/${ROUTE.manageSubscriptions}`,
        adminOnly: true,
      },
      {
        text: "Manage Subscriptions",
        icon: <SubscriptionsIcon />,
        path: `${ROUTE.admin}/${ROUTE.internalSubscriptions}`,
        sudperAdminOnly: true,
      },
    ],
  },
];

const NavBar: React.FC<{ opened: (isOpen: boolean) => void }> = ({ opened }) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const { user, permission } = useAuth();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:850px)');

  const navItems = useMemo(() => {
    const filteredNavItems = navArrItems
      .filter((item) => {
        // if (item.text === 'Service Manager') return true;
        if (item.adminOnly && user?.authorities !== "ROLE_ADMIN") {
          return false;
        }
        if (item.sudperAdminOnly && user?.authorities !== "ROLE_SUPER_ADMIN") {
          return false;
        }
        const permissionCategory = getPermissionCategoryFromNavItem(item.text);
        if (permissionCategory) {
          return hasCategoryAccess(permission, permissionCategory, user);
        }
        return false;
      })
      .map((item) => {
        if (item.children) {
          const permissionCategory = getPermissionCategoryFromNavItem(item.text);
          const filteredChildren = item.children.filter((child) => {
            if (child.adminOnly && user?.authorities !== "ROLE_ADMIN") {
              return false;
            }
            if (child.sudperAdminOnly && user?.authorities !== "ROLE_SUPER_ADMIN") {
              return false;
            }
            const permissionSubcategory = getPermissionSubcategoryFromNavSubcategory(child.text);

            if (permissionCategory && permissionSubcategory) {
              return hasSubcategoryAccess(permission, permissionCategory, permissionSubcategory, user);
            }

            return true;
          });

          return { ...item, children: filteredChildren };
        }

        return item;
      });
    return filteredNavItems;
  }, [user, permission]);

  const [activeItem, setActiveItem] = useState<string>(
    navItems.find((item) => location.pathname.startsWith(item.path))?.text || 'Dashboard',
  );

  // Track open state for each item that has children
  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    opened(isOpen);
  }, [isOpen, opened]);

  useEffect(() => {
    setActiveItem(navItems.find((item) => location.pathname.startsWith(item.path))?.text || 'Dashboard');
  }, [location.pathname]);

  const handleNavItemClick = (item: NavItem) => {
    if (item.children) {
      // Toggle the open state of the clicked item
      setOpenItems((prev) => ({
        ...prev,
        [item.text]: !prev[item.text],
      }));
    } else {
      setActiveItem(item.text);
      navigate(item.path);
    }
  };
  const hoverTimerRef = useRef<NodeJS.Timeout | null>(null);

  // Recursive function to render nav items with nested children
  const renderNavItems = (items: NavItem[], level: number = 0) => {
    return items.map((item) => (
      <Box key={item.text} sx={{ pl: level * 1.5 }}>
        <NavButton
          text={item.text}
          icon={item.icon}
          hasArrow={item.hasArrow}
          isActive={activeItem === item.text}
          isOpen={isOpen && !isSmallScreen}
          onClick={() => handleNavItemClick(item)}
          arrowRotated={!!openItems[item.text]}
        />
        {item.children && openItems[item.text] && renderNavItems(item.children, level + 0.5)}
      </Box>
    ));
  };

  return (
    <Paper
      onMouseEnter={() => {
        if (!isSmallScreen) {
          if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);
          hoverTimerRef.current = setTimeout(() => setIsOpen(true), 100); // slight delay
        }
      }}
      onMouseLeave={() => {
        if (!isSmallScreen) {
          if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);
          hoverTimerRef.current = setTimeout(() => setIsOpen(false), 100); // slight delay
        }
      }}
      sx={{
        width: isSmallScreen ? '56px' : isOpen ? '300px' : '96px',
        padding: isSmallScreen ? '6px' : '24px',
        background: theme.palette.selected,
        transition: 'width 0.4s ease-in-out, padding 0.3s ease-in-out',
        overflowX: 'hidden',
        position: 'relative',
      }}
      className="h-full flex flex-col gap-[24px]"
    >
      {/* Navbar Header */}
      <Box className="flex items-center justify-start gap-2">
        {isOpen && !isSmallScreen ? (
          theme.palette.mode === 'light' ? (
            <img src={companyLogoDark} alt="Logo" className="h-[40px]" />
          ) : (
            <img src={companyLogoLight} alt="Logo" className="h-[40px]" />
          )
        ) : (
          <img src={logoName} alt="Logo" className="h-[40px] w-[40px]" />
        )}
      </Box>

      {/* Navbar List */}
      <List className="mt-8 flex flex-col gap-[16px]">{renderNavItems(navItems)}</List>
    </Paper>
  );
};

export default NavBar;
